import React from "react";

export default function LockableButton({
  locked,
  lockedTitle,
  className,
  style,
  onClick,
  children,
  ...rest
}) {
  if (locked) {
    return (
      <button
        type="button"
        className={className}
        disabled
        title={lockedTitle}
        style={{ ...style, opacity: 0.55, cursor: "not-allowed" }}
        {...rest}
      >
        🔒 {children}
      </button>
    );
  }
  return (
    <button type="button" className={className} onClick={onClick} style={style} {...rest}>
      {children}
    </button>
  );
}
